import paymentsServices from '@/api/paymentServices';
import { RootState } from '@/app/store';
import { StandingOrder } from '@/interfaces/reccuringData';
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

interface FilterParams {
  sort: string | undefined;
  page: number | undefined;
  size: number | undefined;
}
interface MetaData {
  totalPages: number;
  totalElements: number;
}
interface StandingOrderState {
  currFilters: string;
  standingOrders: { [key: string]: StandingOrder[] };
  metaData: { [key: string]: MetaData };
  loading: boolean;
  params: FilterParams;
}

const initialState: StandingOrderState = {
  currFilters: '',
  standingOrders: {},
  metaData: {},
  loading: false,
  params: {
    sort: undefined,
    page: undefined,
    size: undefined,
  },
};

export const deleteStandingOrder = createAsyncThunk('recPayment/delete', async (id: string, thunkAPI) => {
  try {
    const result = await paymentsServices.removeStandingOrder(id);
    return result;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.data);
  }
});

export const fetchStandingOrders = createAsyncThunk(
  'recPayment/findAll',
  async ({ size, page, sort }: { size: number; page: number; sort: string }) => {
    return paymentsServices.loadStandingOrders({ size, page: page - 1, sort });
  }
);

export const standingOrderSlice = createSlice({
  name: 'standingOrders',
  initialState,
  reducers: {
    refresh: () => initialState,
    clearOrder: state => {
      state.standingOrders = {};
    },
    handleParamsChange: (state, action: PayloadAction<{ size: number; page: number; sort: string }>) => {
      const stringifyFilters = JSON.stringify(action.payload);
      state.currFilters = stringifyFilters;
      state.params.page = action.payload.page;
      state.params.sort = action.payload.sort;
      state.params.size = action.payload.size;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchStandingOrders.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchStandingOrders.fulfilled, (state, action) => {
      const { payload } = action;
      state.standingOrders[state.currFilters] = payload.data;
      state.metaData[state.currFilters] = { totalPages: payload.totalPages, totalElements: payload.totalElements };
      state.loading = false;
    });
    builder.addCase(fetchStandingOrders.rejected, state => {
      state.loading = false;
    });
  },
});

export const { handleParamsChange, refresh, clearOrder } = standingOrderSlice.actions;

export const selectStandingOrder = (state: RootState) => state.standingOrder;

export default standingOrderSlice.reducer;
